import React, { useState } from "react";
import { Modal, Button, Card } from "react-bootstrap";
import CustomToast from "../Toast";
import AuctionCard from "../../pages/allModals/saleprogram/maintanance/Maintananse";

const ConfirmationModalWithExcel = ({
  show,
  onHide,
  onDelete,
  setRemark,
  remarkShow,
  uploadedFiles,
  setUploadedFiles,
  resateForm,
  currentDate,
  rows,
  saleDates,
  setSaleDates,
  formData,
  year,
  saleNumber,
  setSelectedSaleProgram,
  handleYearChange,
  generateYearOptions,
  actionData,
  selectedSaleProgram,
  isDisabled,
  isEdit,
  setYears,
  setSelectedSalePrograms,
  selectedSalePrograms,
  saleProgramDetailList,
  setSaleProgramDetailList,
  selectedSaleNo,
  setSelectedSaleNo,
  publishingDate,
  setPublishingDate,
  closingDate,
  setClosingDate,
  numRows,
  setNumRows,
  handleChange,
  setExpanded,
  setLotConfiguration,
  lotConfiguration,
  auctionVarient,
  setAuctionVarient,
  setPrsAuctionSessionId,
  prsAuctionSessionId,
  isChecked,
  setIsChecked,
  setAverageInPercentage,
  averageInPercentage,
  modalRight,
  auctionType,
  auctionTypeCode,
  handleSearch,
  uploadedFilesData,
  setUploadedFilesData
}) => {
  const [removeFilesnew, setRemoveFilenew] = useState(null);

  const [remark] = useState(remarkShow ? remarkShow : true);
  const handleDelete = (e) => {
    onDelete(e, uploadedFiles); // Perform actual delete action
  };

  const onHideModal = () => {
    // setUploadedFiles([])
    onHide();
  };
  const formatdate = (dates, ismonthprev) => {
    const date = new Date(dates);
    const day = date.getDate();
    const month = date.getMonth() + 1; // January is 0
    const year = date.getFullYear() % 100; // Get last two digits of year
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    // Add leading zero if the number is less than 10
    const formattedDay = (day < 10 ? "0" : "") + day;
    const formattedMonth = (month < 10 ? "0" : "") + month;
    // const formattedYear = (year < 10 ? "0" : "") + year;
    const formattedHours = (hours < 10 ? "0" : "") + hours;
    const formattedMinutes = (minutes < 10 ? "0" : "") + minutes;
    const formattedSeconds = (seconds < 10 ? "0" : "") + seconds;
    
    // const formattedDate = `${formattedDay}/${date.getMonth() + 1}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
    let formattedDate;
    if (ismonthprev === true) {
      formattedDate = `${formattedMonth}/${formattedDay}/${date.getFullYear()} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    } else {
      formattedDate = `${formattedDay}/${formattedMonth}/${date.getFullYear()} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    }

    return formattedDate;
  }
  const getFormattedDateTime = () => {
    const currentDate = new Date();
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1; // January is 0
    const year = currentDate.getFullYear() % 100; // Get last two digits of year
    const hours = currentDate.getHours();
    const minutes = currentDate.getMinutes();

    // Add leading zero if the number is less than 10
    const formattedDay = (day < 10 ? "0" : "") + day;
    const formattedMonth = (month < 10 ? "0" : "") + month;
    const formattedYear = (year < 10 ? "0" : "") + year;
    const formattedHours = (hours < 10 ? "0" : "") + hours;
    const formattedMinutes = (minutes < 10 ? "0" : "") + minutes;
    
    // Construct the date and time string in the format dd/mm/yy hh:min
    return `${formattedDay}/${formattedMonth}/${formattedYear} ${formattedHours}:${formattedMinutes}`;
  }

  const handleFileUpload = async (event) => {
    const files = event.target.files;
    const updatedFiles = uploadedFiles === null ? [] : [...uploadedFiles];
    const existingFileNames = updatedFiles.map(
      (uploadedFile) => uploadedFile.documentName.split(".")[0]
    );

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const fileNameWithoutExtension = file.name.replace(/\.[^/.]+$/, "");
      const isExistingFile = existingFileNames.includes(file.name);
      const isSameNameDifferentExtension = existingFileNames.includes(
        fileNameWithoutExtension
      );
      if (isExistingFile || isSameNameDifferentExtension) {
        CustomToast.warning(`File "${file.name}" already exists.`);
        continue; // Skip this file and proceed to the next one
      }
      if (
        !allowedFileExtensions.includes(fileExtension) ||
        existingFileNames.includes(fileNameWithoutExtension)
      ) {
        CustomToast.error(
          `File "${file.name}" is not allowed or already exists.`
        );
        continue; // Skip this file and proceed to the next one
      }
      if (file.size <= MAX_FILE_SIZE) {
        try {
          // Read the file content as a Base64 string using FileReader and async/await
          const base64Content = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => {
              // Extract the Base64 content from the data URI
              const base64String = event.target.result.split(",")[1];
              resolve(base64String);
            };

            reader.onerror = (event) => {
              reject(event.target.error);
            };

            // Read the file as a data URL
            reader.readAsDataURL(file);
          });

          const fileInfo = {
            documentName: file.name,
            // documentPath: file.pathName,
            documentBrief: "", // Empty document brief, you can set the actual brief value
            DocumentSize: `${(file.size / (1024 * 1024)).toFixed(2)}MB`,
            status: 0,
            documentBytes: base64Content, // Store the Base64 content in fileInfo
            // contentType: file.type,
            documentDateAndTime: formatdate(new Date(), true),
          };
          updatedFiles.push(fileInfo);
          console.log(event, "fileInfofileInfo");
        } catch (error) {
          console.error("Error reading the file:", error);
          // Handle the error as per your requirement (e.g., show an error message)
        }
      } else {
        CustomToast.error(`File "${file.name}" has more than 10MB.`);
      }
    }

    // Update the state after all files have been processed
    setUploadedFiles(updatedFiles);
  };

  const updateFileBrief = (index, brief) => {
    const updatedFiles = uploadedFiles === null ? [] : [...uploadedFiles];
    updatedFiles[index].documentBrief = brief;
    updatedFiles[index].status = 0;
    setUploadedFiles(updatedFiles);
  };
  const removeFile = (index) => {
    const updatedFiles = [...uploadedFiles];
    URL.revokeObjectURL(updatedFiles[index].path); // Release the object URL
    updatedFiles.splice(index, 1);
    setUploadedFiles(updatedFiles);
  };

  return (
    <>
      <Modal show={show} size="xl" onHide={onHide} animation={true} className="DeleteModal">
        <form>
          <Modal.Header>
            <Modal.Title>Cancel sale Program</Modal.Title>
            <i className="fa fa-times CloseModal" onClick={onHideModal}></i>
          </Modal.Header>
          <Modal.Body>
            {/* <h3>Upload </h3> */}
            {/* <RedView /> */}
            <AuctionCard
              resateForm={resateForm}
              currentDate={currentDate}
              rows={rows}
              saleDates={saleDates}
              setSaleDates={setSaleDates}
              formData={formData}
              year={year}
              saleNumber={saleNumber}
              uploadedFiles={uploadedFilesData}
              setUploadedFiles={setUploadedFilesData}
              setSelectedSaleProgram={setSelectedSaleProgram}
              handleYearChange={handleYearChange}
              generateYearOptions={generateYearOptions}
              actionData={actionData}
              selectedSaleProgram={selectedSaleProgram}
              isDisabled={isDisabled}
              isEdit={isEdit}
              setYears={setYears}
              setSelectedSalePrograms={setSelectedSalePrograms}
              selectedSalePrograms={selectedSalePrograms}
              saleProgramDetailList={saleProgramDetailList}
              setSaleProgramDetailList={setSaleProgramDetailList}
              selectedSaleNo={selectedSaleNo}
              setSelectedSaleNo={setSelectedSaleNo}
              publishingDate={publishingDate}
              setPublishingDate={setPublishingDate}
              closingDate={isEdit === true ? closingDate : closingDate}
              setClosingDate={setClosingDate}
              numRows={numRows}
              setNumRows={setNumRows}
              handleChange={handleChange}
              setExpanded={setExpanded}
              setLotConfiguration={setLotConfiguration}
              lotConfiguration={lotConfiguration}
              auctionVarient={auctionVarient}
              setAuctionVarient={setAuctionVarient}
              setPrsAuctionSessionId={setPrsAuctionSessionId}
              prsAuctionSessionId={prsAuctionSessionId}
              isChecked={isChecked}
              setIsChecked={setIsChecked}
              setAverageInPercentage={setAverageInPercentage}
              averageInPercentage={averageInPercentage}
              modalRight={modalRight}
              auctionType={auctionType}
              auctionTypeCode={auctionTypeCode}
              handleSearch={handleSearch}
            />
            <div className="FileUpload mt-3">
              {/* {uploadedFiles?.map((file, index) => (
                <div className="UploadedFile" key={index}>
                  <div>
                    <Card>
                      {file?.status === 0
                        ? "Pending"
                        : file?.status === 1
                          ? "Active"
                          : file?.status === 2
                            ? "Cancelled"
                            : ""}
                    </Card>
                   
                  </div>

                  <i
                    className="fa fa-times"
                    onClick={() => removeFile(index)}
                  ></i>
                </div>
              ))} */}
              <input
                type="file"
                multiple
                // onChange={handleFileUpload}
                id="fileInput"
                className="p-2"
                onChange={handleFileUpload}
              />
            </div>
            <div className="TableBox">
              <table className="table">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Document Name</th>
                    <th>Document Size</th>
                    <th>Status</th>
                    <th>Document Uploaded Date & Time</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {uploadedFiles?.map((file, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <span>
                          {isDisabled == true || isEdit == true
                            ? file?.documentName
                            : file?.documentName}
                        </span>
                      </td>

                      <td>{file?.DocumentSize}</td>
                      <td>
                        {/* {isDisabled == true || isEdit == true ? (
                              <> */}
                        {file?.status === 0
                          ? "Pending"
                          : file?.status === 1
                            ? "Approved"
                            : file?.status === 2
                              ? "Cancelled"
                              : ""}
                      </td>
                      <td>
                        {isDisabled == true || isEdit == true
                          ? file?.documentDateAndTime !== null ||
                            file?.documentDateAndTime != ""
                            ? formatdate(file?.documentDateAndTime, false)
                            : ""
                          : getFormattedDateTime()}
                      </td>

                      <td>


                        <button
                          style={{
                            backgroundColor: "transparent",
                            cursor: "pointer",
                          }}
                          type="button"
                          onClick={() => setRemoveFilenew(index)}
                        >
                          <i
                            className="fa fa-cancel"
                            style={{ color: "red", cursor: "pointer" }}
                          ></i>
                        </button>
                        {/* <i
                            className="fa fa-times"
                            onClick={() => removeFile(index)}
                          ></i> */}


                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <input
              className="fomr-control w-100 mt-3"
              style={{ display: remarkShow === true ? "block" : "none" }}
              type="textarea"
              required
              onChange={(e) => setRemark(e.target.value)}
              placeholder="Enter Remarks"
            />

            <div className="BtnGroup">
              <Button className="SubmitBtn" type="submit" onClick={handleDelete}>
                Submit
              </Button>
              <Button className="SubmitBtn" onClick={onHideModal}>
                Cancel
              </Button>
            </div>
          </Modal.Body>
        </form>
      </Modal>
  

      <Modal
        title="Are you sure you want to delete this document ?"
        show={removeFilesnew !== null}
        handleClose={() => setRemoveFilenew(null)}
        size="l"
      >
        <Modal.Header>
          <Modal.Title>Are you sure you want to delete this document ?</Modal.Title>
          <i className="fa fa-times CloseModal" onClick={() => setRemoveFilenew(null)}></i>
        </Modal.Header>
        <Modal.Body>
          <div className="BtnGroup">
            <button className="SubmitBtn" onClick={() => { removeFile(removeFilesnew); setRemoveFilenew(null) }}>OK</button>
            <button className="ms-3 SubmitBtn" onClick={() => setRemoveFilenew(null)}>
              Cancel
            </button>
          </div>
        </Modal.Body>

      </Modal>
    </>
  );
};

export default ConfirmationModalWithExcel;

const MAX_FILE_SIZE = 10 * 1024 * 1024;

const allowedFileExtensions = [
  "txt",
  "zip",
  "pdf",
  "jpg",
  "jpeg",
  "gif",
  "bmp",
  "png",
  "tif",
  "tiff",
  "doc",
  "xls",
  "ppt",
  "pps",
  "dxf",
  "docx",
  "xlsx",
  "eml",
  "rar",
];
